module.exports = __webpack_public_path__ + "static/media/Inter-BoldItalic.3aa31f73.woff";